<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'compensation',
      breadcrumb: [
        { name: "财务管理", path: `/finance/shipper` },
        { name: "应收账款管理", path: `/finance/shipper` },
        { name: "客户合同补差" },
      ],
      formInline: {},
      formCtrl: [
        {
          // label: "合同编号：",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "shname", label: "客户名称" },
        { keyName: "endtime", label: "合同截止日期" },
        { keyName: "money", label: "补差金额" },
        { keyName: "edittime", label: "补差时间"},
        { keyName: "content", label: "备注信息"},
      ],
      getTotalProperty: [],
      baseParams: ['cid'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
